import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from "react-bootstrap";
import PageHeader from '../../components/pageHeader/pageHeader.component';
import PublicationCard from '../../components/publicationCard/publicationCard.component';
import PublicationCatMenu from './publicationCatMenu.component';

import PublicationsPageCover from '../../assets/images/banners/about-intro.png';

import './PublicationsPage.module.css';

const PublicationsPage = props => {

    const { publications } = useSelector(state => state.all)

    return (
        <div>
            <PageHeader
                title="গাইড এবং প্রশ্নব্যাংক"
            />
            <section className='pt-0' styleName="publication-list-section">
                <Container className='bg-light mb-5' fluid>
                    <PublicationCatMenu />
                </Container>
                <Container >

                    <Row>
                        {publications && publications.map((item, index) =>
                            <Col xs={6} md={4} lg={3} className="mb-5" key={`publication_${index + 1}`}>
                                <PublicationCard item={item} />
                            </Col>)}
                    </Row>

                </Container>
            </section>
        </div>
    )
}

export default PublicationsPage;